var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleLikePin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793.7 793.7",
    style: {
      enableBackground: "new 0 0 793.7 793.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1_00000088105188978511793620000008789873346183805068_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.9,3.6c-38,0-68.7,30.8-68.7,68.7c0,27.4,16,51,39.1,62v655.8h59.2V134.3c23.1-11.1,39.1-34.7,39.1-62 C465.6,34.3,434.8,3.6,396.9,3.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M287.7,98.8c0-5.9-3.2-11.1-7.9-14c1.8-2.6,2.9-5.8,2.9-9.2c0-9-7.3-16.3-16.3-16.3H232c1.1-4.8,2.5-12,3.5-19.5 c2.6-19.5,0.8-30.3-5.6-34.1c-4-2.3-8.3-2.8-12.2-1.3c-3,1.1-7,3.9-9.3,10.7l-9.1,23.7c-4.6,11.3-18.6,23.2-27.3,29.8v84.4 c16.1,5.7,32.9,8.5,50.1,8.5h37.5c9,0,16.3-7.3,16.3-16.3c0-3.2-0.9-6.1-2.5-8.6c5.4-2.7,9.2-8.2,9.2-14.7 c0-3.4-1.1-6.6-2.9-9.2C284.5,110,287.7,104.8,287.7,98.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.9,288.5c-36,0-65.1,29.2-65.1,65.1h130.1C294.9,317.6,265.8,288.5,229.9,288.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.9,
    cy: 232.8,
    r: 37.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleLikePin);
export default __webpack_public_path__ + "static/media/peopleLikePin.0e0807f64fdf7f4208b20200f0f8ffda.svg";
export { ForwardRef as ReactComponent };